/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { descriptor as parentDescriptor } from '@carbon/web-components/es/components-react/link/link.js';
import { propTypes as parentPropTypes } from '@carbon/web-components/es/components-react/link/link.js';
export { default as CustomElement } from '../../components/card/card.js';
import createReactCustomElementType from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var c4dPrefix = settings.stablePrefix;
export var descriptor = Object.assign({}, parentDescriptor, {
  onRequestAdditionalVideoData: {
    event: ''.concat(c4dPrefix, '-cta-request-additional-video-data'),
  },
  onVideoTitleUpdated: {
    event: ''.concat(c4dPrefix, '-card-video-title-updated'),
  },
});
export var propTypes = {
  /**
   * The name of the custom event fired when there is a user gesture to run the action.
   */
  onRequestAdditionalVideoData: PropTypes.func,
  /**
   * The name of the custom event fired when the video title is updated
   */
  onVideoTitleUpdated: PropTypes.func,
};
const Component = createReactCustomElementType(
  ''.concat(c4dPrefix, '-card'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
